function jobApplicationForm() {
	const jobApplicationFormId = window.theme_vars.job_application_form_id;
	const hideRepeatersAndNotes = ( formModel ) => {
		const fields = formModel.get( "fields" );
		const fieldsToHide = fields.models.filter( ( item ) => {
			const key = item.get( "key" );
			return (
				key.startsWith( "professional_reference" ) ||
				key.startsWith( "previous_employment" ) ||
				key === "additional_professional_references_note" ||
				key === "additional_previous_employment_note"
			);
		} );
		fieldsToHide.forEach( ( item ) => {
			item.set( "visible", false );
			item.trigger( "reRender", item );
		} );
	};

	$( document ).on( "nfFormSubmitResponse", function( event, response ) {
		const formId = response?.id;
		if ( formId !== jobApplicationFormId ) {
			return;
		}

		$( `#nf-form-${formId}-cont` )
			.removeClass( "limit-professional-reference" )
			.removeClass( "limit-previous-employment" );

		const formModel = nfRadio.channel( "app" ).request( "get:form" , formId );
		const formChannel = nfRadio.channel( "form-" + formModel.get( "id" ) );
		[ "show_professional_reference_btn", "show_previous_employment_btn" ].forEach( ( key ) => {
			const showBtn = formChannel.request( "get:fieldByKey", key );
			showBtn.set( "visible", true );
		} );
		hideRepeatersAndNotes( formModel );
	} );

	if ( typeof Marionette !== "undefined" ) {
		const customController = Marionette.Object.extend( {
			initialize: function() {
				this.listenTo( nfRadio.channel( "form" ), "render:view", function( event ) {
					const formModel = event.model;
					const formId = formModel.get( "id" );
					if ( formId !== jobApplicationFormId ) {
						return;
					}

					hideRepeatersAndNotes( formModel );
				} );

				/* eslint-disable complexity */
				this.listenTo( nfRadio.channel( "field-repeater" ), "add:fieldset", function( id ) {
					setTimeout( () => {
						const model = nfRadio.channel( "fields" ).request( "get:field", id );
						const key = model.get( "key" );
						const sets = model.get( "sets" );
						const $formCont = $( `#nf-form-${model.get( "formID" )}-cont` );

						if ( key.startsWith( "professional_reference" ) && sets.length >= 2 ) {
							$formCont.addClass( "limit-professional-reference" );
						} else if ( key.startsWith( "previous_employment" ) && sets.length >= 2 ) {
							$formCont.addClass( "limit-previous-employment" );
						}
					}, 0 );
				} );
				/* eslint-enable complexity */

				/* eslint-disable complexity */
				this.listenTo( nfRadio.channel( "field-repeater" ), "remove:fieldset", function( event ) {
					setTimeout( () => {
						const model = event.repeaterFieldModel;
						const key = model.get( "key" );
						const sets = model.get( "sets" );
						const $formCont = $( `#nf-form-${model.get( "formID" )}-cont` );

						if ( key.startsWith( "professional_reference" ) && sets.length < 2 ) {
							$formCont.removeClass( "limit-professional-reference" );
						} else if ( key.startsWith( "previous_employment" ) && sets.length < 2 ) {
							$formCont.removeClass( "limit-previous-employment" );
						}
					}, 0 );
				} );
				/* eslint-enable complexity */

				/* eslint-disable complexity */
				this.listenTo( nfRadio.channel( "nfMP" ), "change:part", function( model ) {
					const formModel = model.formModel;
					const formId = formModel.get( "id" );
					if ( formId !== jobApplicationFormId ) {
						return;
					}

					const $formCont = $( `#nf-form-${formId}-cont` );
					const formContentData = formModel.get( "formContentData" );
					const currentElementOrder = formContentData.currentElement.get( "order" );
					const formChannel = nfRadio.channel( "form-" + formModel.get( "id" ) );
					const fields = formModel.get( "fields" );
					const setListeners = ( showBtnKey, noteKey, repeaterKey ) => {
						const showBtn = formChannel.request( "get:fieldByKey", showBtnKey );
						const note = formChannel.request( "get:fieldByKey", noteKey );
						const repeater = fields.models.find( ( item ) => {
							const key = item.get( "key" );
							return key.startsWith( repeaterKey );
						} );
						const deleteBtnHandler = () => {
							const sets = repeater.get( "sets" );

							if ( sets.length > 1 ) {
								nfRadio.channel( "field-repeater" ).trigger( "remove:fieldset", sets.models[0] );
							} else {
								nfRadio.channel( "field-repeater" ).trigger( "add:fieldset", repeater.get( "id" ) );
								nfRadio.channel( "field-repeater" ).trigger( "remove:fieldset", sets.models[0] );
								repeater.set( "visible", false );
								repeater.trigger( "reRender", repeater );
								note.set( "visible", false );
								note.trigger( "reRender", note );
								showBtn.set( "visible", true );
								showBtn.trigger( "reRender", showBtn );

								setListeners( showBtnKey, noteKey, repeaterKey );
							}
						};

						if ( repeater && showBtn && note ) {
							$formCont
								.find( `#nf-field-${showBtn.get( "id" )}-wrap button` )
								.on( "click", () => {
									repeater.set( "visible", true );
									repeater.trigger( "reRender", repeater );
									note.set( "visible", true );
									note.trigger( "reRender", note );
									showBtn.set( "visible", false );
									showBtn.trigger( "reRender", showBtn );

									$formCont
										.find( `#nf-field-${note.get( "id" )}-wrap button` )
										.on( "click", deleteBtnHandler );
								} );

							if ( note.get( "visible" ) ) {
								$formCont
									.find( `#nf-field-${note.get( "id" )}-wrap button` )
									.on( "click", deleteBtnHandler );
							}
						}
					};

					if ( currentElementOrder === 2 ) {
						setListeners( "show_professional_reference_btn", "additional_professional_references_note", "professional_reference" );
					} else if ( currentElementOrder === 3 ) {
						setListeners( "show_previous_employment_btn", "additional_previous_employment_note", "previous_employment" );
					}
				} );
				/* eslint-enable complexity */
			},
		} );

		// initialise listening controller for ninja form
		new customController();
	}
}

$( function() {
	jobApplicationForm();
} );
